import { render, staticRenderFns } from "./VATReportBEHome.vue?vue&type=template&id=00ea5c01&"
import script from "./VATReportBEHome.vue?vue&type=script&lang=js&"
export * from "./VATReportBEHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports